import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=7de2c41d"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme5PlayerBalance: require('/app/components/Theme5/PlayerBalance.vue').default,Theme5DesktopNavProfileDropdown: require('/app/components/Theme5/Desktop/Nav/ProfileDropdown.vue').default,Theme5ComponentsSwitchLanguage: require('/app/components/Theme5/Components/SwitchLanguage.vue').default,Theme5DesktopNavNotificationDropdown: require('/app/components/Theme5/Desktop/Nav/NotificationDropdown.vue').default,Theme5SideNavMini: require('/app/components/Theme5/SideNavMini.vue').default,Theme5SideNav: require('/app/components/Theme5/SideNav.vue').default,Theme5DesktopTopDepositRanking: require('/app/components/Theme5/Desktop/TopDepositRanking.vue').default})
